import React, { useState } from 'react';
import UserInfoForm from './UserInfoForm';

interface EditProfileModalProps {
  isOpen: boolean;
  onClose: () => void;
  userData: {
    username: string;
    email: string;
    firstName?: string;
    lastName?: string;
    profileImageUrl?: string;
    gender?: string | null;
  };
  onSuccess: () => void;
}

const EditProfileModal: React.FC<EditProfileModalProps> = ({ isOpen, onClose, userData, onSuccess }) => {
  if (!isOpen) return null;
  
  const handleSuccess = () => {
    onSuccess();
    onClose();
  };
  
  // Ngăn việc click trên nền đen đóng modal
  const handleModalContentClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };
  
  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <h2 className="modal-title">CẬP NHẬT THÔNG TIN</h2>
        
        <UserInfoForm 
          initialData={userData}
          onSuccess={handleSuccess}
          onCancel={onClose}
        />
      </div>
    </div>
  );
};

export default EditProfileModal; 